// extracted by mini-css-extract-plugin
module.exports = {"gradient-box":"background_animation_gradient-box__FSrqy","gradient":"background_animation_gradient__ARbcd"};